var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.249,
    height: 27.041,
    viewBox: "0 0 27.249 27.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(-478.527 -404.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_455_",
    transform: "translate(478.527 403.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_458_",
    d: "M1.246,130.873H11.68a8.723,8.723,0,1,0-.157-10.595A9.553,9.553,0,0,0,0,129.627,1.246,1.246,0,0,0,1.246,130.873Zm17.28-11.631a6.231,6.231,0,1,1-6.231,6.231A6.238,6.238,0,0,1,18.526,119.242Z",
    transform: "translate(0 -105.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_461_",
    d: "M57.462,1.25a5.213,5.213,0,1,0,5.213,5.213A5.219,5.219,0,0,0,57.462,1.25Z",
    transform: "translate(-47.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_462_",
    d: "M179.246,181.735h1.246v1.246a1.246,1.246,0,0,0,2.492,0v-1.246h1.246a1.246,1.246,0,0,0,0-2.492h-1.246V178a1.246,1.246,0,0,0-2.492,0v1.246h-1.246a1.246,1.246,0,0,0,0,2.492Z",
    transform: "translate(-163.213 -160.92)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateUser);
export default __webpack_public_path__ + "static/media/create_user.2f9ef5db1f28ea0a34ae771c977b383a.svg";
export { ForwardRef as ReactComponent };